module.exports = __webpack_public_path__ + "media/newstyle/images/icon-questionmark-orange-a0bd7b1606013a1e9cb06da7747f3ec9.svg";